import { Button } from "@heroui/react";
import { IconPlus, IconMinus, IconEye } from "@tabler/icons-react";
import { useAddCard } from "@/stores/deckStore";

export default function CardButtons({
  handleOpen,
  aaCardId,
}: {
  handleOpen: any;
  aaCardId: string;
}) {
  const addCard = useAddCard();
  const buttonStyle = {
    height: "34px",
    width: "34px",
  };
  const buttonClassName = `bg-slate-800 min-w-0 min-h-0 invisible group-hover:visible mt-[2px] outline outline-1 outline-offset-[-1px] outline-slate-200`;
  return (
    <>
      <Button
        isIconOnly
        onPress={() => handleOpen(aaCardId)}
        style={buttonStyle}
        radius="full"
        className={buttonClassName}
      >
        <IconEye height={18} width={18} />
      </Button>
      <Button
        isIconOnly
        radius="full"
        className={buttonClassName}
        onPress={() => addCard(aaCardId, 1)}
        style={buttonStyle}
      >
        <IconPlus height={18} width={18} />
      </Button>
      <Button
        isIconOnly
        radius="full"
        className={buttonClassName}
        onPress={() => addCard(aaCardId, -1)}
        style={buttonStyle}
      >
        <IconMinus height={18} width={18} />
      </Button>
    </>
  );
}
